// THIS ASSET IS CREATED AUTOMATICALLY FROM THE MAKE SCENARIO ENTITLED "REVIEW COUNTER UPDATES" - DO NOT EDIT HERE! //

// Last updated on 2025-03-17T08:51:54.982Z //

document.addEventListener('DOMContentLoaded', function () {
  const totalReviews = 9331; // Make dynamic update
  const averageRating = 4.80;

  // Expose globally for other scripts
  window.totalReviews = totalReviews;
  window.averageRating = averageRating;

  // Update total reviews
  document.querySelectorAll('#total-reviews').forEach(el => {
    el.textContent = totalReviews;
  });

  // Update average rating
  document.querySelectorAll('#average-rating').forEach(el => {
    el.textContent = averageRating.toFixed(1);
  });
});
